import React, { useState, useEffect, useRef } from 'react'
import Matter from "matter-js";
import { motion } from "framer-motion";

import './Serve.css'

import MediaLoading from '../Loadings/MediaLoading'
import NavHeader from '../Components/NavHeader'
import MobileNavHeader from '../Components/MobileNavHeader'
import MobileNav from '../Components/MobileNav'
import CircleCard from '../Components/CircleCard'
import SecondFooter from '../Components/SecondFooter'

import media from '../assets/icons/media_icon.svg'
import pill from '../assets/pills/media_pill.svg'
import arrow_l from '../assets/arrow_l.svg'
import arrow_r from '../assets/arrow_r.svg'

import khu from '../assets/media/video_khushow/khushow_thumbnail.png'
import ozel from '../assets/media/uiux_ozel/ozel_thumbnail.png'
import rest from '../assets/media/cg_takearest/takearest_thumbnail.png'
import pop from '../assets/media/animation_pop/pop_thumbnail.png'
import shimshim from '../assets/media/interaction_shimshim/shimshim_thumbnail.png'
import souvenir from '../assets/media/motion_souvenir/souvenir_thumbnail.png'
import famsupport from '../assets/media/uiux_famsupport/famsupport_thumbnail.png'
import oneul from '../assets/media/uiux_oneul/oneul_thumbnail.png'

function Media() {

    const matterRef = useRef(null);

    const serveType = 'media'
    const itemList = [
        { id: 5, title: '2024 KHU show', type: 'Video', image: khu },
        { id: 8, title: 'Take a rest', type: 'CG', image: rest },
        { id: 9, title: 'Oneul', type: 'UIUX', image: oneul },
        { id: 2, title: 'Shimshim', type: 'UIUX', image: shimshim },
        { id: 1, title: 'Pop', type: 'Motion', image: pop },
        { id: 7, title: 'Ozel', type: 'UIUX', image: ozel },
        { id: 4, title: 'Famsupport', type: 'UIUX', image: famsupport },
        { id: 3, title: 'Souvenir', type: 'Motion', image: souvenir },
    ]

    const [isLoading, setIsLoading] = useState(true)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [filter, setFilter] = useState('all')

    const [itemPosition, setItemPosition] = useState(0);
    const [x, setX] = useState(0); //188.5
    const [y, setY] = useState(0);
    const [rotate, setRotate] = useState(0);
    function moveItemBackward() {
        if (itemPosition > 0) {
            setItemPosition(itemPosition - 1);
            setX(x + 324);
        } else {
            setItemPosition(itemList.length - 1);
            setX(-324 * (itemList.length - 1));
        }
    
        console.log('x', x);
        console.log('itemPosition', itemPosition);
    }
    
    function moveItem() {
        if (itemPosition < itemList.length - 1) {
            setItemPosition(itemPosition + 1);
            setX(x - 324);
        } else {
            setItemPosition(0);
            setX(0)
        }

        console.log('x', x)
        console.log('itemPositon', itemPosition)
    }

    useEffect(() => {
        const reloadCount = sessionStorage.getItem('reloadCount');
        if (reloadCount < 2) {
            sessionStorage.setItem('reloadCount', String(reloadCount + 1));
            window.location.reload(false);
        } else {
            sessionStorage.removeItem('reloadCount');
        }
    }, [])

    useEffect(() => {
        window.scrollTo({
            top: 0,
        });
        setTimeout(() => {
            setIsLoading(false)
        }, 1500);

        var body = document.body,
        html = document.documentElement;

        var height = Math.max(body.scrollHeight, body.offsetHeight,
            html.clientHeight, html.scrollHeight, html.offsetHeight) - 190;

        var Engine = Matter.Engine,
            Render = Matter.Render,
            World = Matter.World,
            MouseConstraint = Matter.MouseConstraint,
            Mouse = Matter.Mouse,
            Bodies = Matter.Bodies;

        var engine = Engine.create()

        var render = Render.create({
            element: matterRef.current,
            engine: engine,
            options: {
                width: window.innerWidth,
                height: height,
                wireframes: false,
                background: 'transparent',
                wireframeBackground: 'transparent'
            }
        });

        var topWall = Bodies.rectangle(window.innerWidth / 2 - 50, -50, window.innerWidth - 50, 50, { isStatic: true, render: { fillStyle: "fff" } }),
            bottomWall = Bodies.rectangle(window.innerWidth / 2, height, window.innerWidth, 50, { isStatic: true, render: { fillStyle: "fff" } }),
            leftWall = Bodies.rectangle(window.innerWidth + 50, height / 2, 50, height, { isStatic: true, render: { fillStyle: "fff" } }),
            rightWall = Bodies.rectangle(-50, height / 2, 50, height, { isStatic: true, render: { fillStyle: "fff" } })
            
        const pill1 = Bodies.rectangle(650, 400, 115, 43.5, {
            restitution: 0.5,
            chamfer: 1000,
            render: { sprite: { texture: pill } }
        }),
            pill2 = Bodies.rectangle(600, 400, 115, 43.5, {
                restitution: 0.5,
                chamfer: 1000,
                render: { sprite: { texture: pill } }
            }),
            pill3 = Bodies.rectangle(950, 400, 115, 43.5, {
                restitution: 0.5,
                chamfer: 1000,
                render: { sprite: { texture: pill } }
            }),
            pill4 = Bodies.rectangle(1000, 400, 115, 43.5, {
                restitution: 0.5,
                chamfer: 1000,
                render: { sprite: { texture: pill } }
            }),
            pill5 = Bodies.rectangle(900, 400, 115, 43.5, {
                restitution: 0.5,
                chamfer: 1000,
                render: { sprite: { texture: pill } }
            });

        World.add(engine.world, [topWall, bottomWall, leftWall, rightWall, pill1, pill2, pill3, pill4, pill5]);

        var mouse = Mouse.create(render.canvas),
            mouseConstraint = MouseConstraint.create(engine, {
                mouse: mouse,
                constraint: {
                    stiffness: 0.2,
                    render: {
                        visible: false
                    }
                }
            });
        mouseConstraint.mouse.element.removeEventListener("mousewheel", mouseConstraint.mouse.mousewheel);
        mouseConstraint.mouse.element.removeEventListener("DOMMouseScroll", mouseConstraint.mouse.mousewheel);
        render.mouse = mouse;

        World.add(engine.world, mouseConstraint);
        // fit the render viewport to the scene
        Render.lookAt(render, {
            min: { x: 0, y: 0 },
            max: { x: window.innerWidth, y: height }
        });

        Matter.Runner.run(engine);
        Render.run(render);

    }, [])

    return (
        <div className='page'>
            {isLoading ? <MediaLoading /> : null}
            <div id="media" className='page'>
                <NavHeader isNav={true} isAbout={false} isBlog={false} />
                <MobileNavHeader setIsModalOpen={setIsModalOpen} />
                {isModalOpen ? <MobileNav setIsModalOpen={setIsModalOpen} /> : null}
                <div className="serveBody flex-col">
                    <div className='matter' ref={matterRef} />
                    <img src={media} alt="" id="mediaIcon" />
                    <div className="serveText">MEDIA DESIGN</div>
                    <div id='mediaFilter' className="filter flex">
                        <div id='mediaFilterAll' className='filterItem' style={{ color: filter === 'all' ? '#161619' : '#7E7E86', fontWeight: filter === 'all' ? '700' : null }} onClick={() => setFilter('all')}>ALL</div>
                        <div className='filterItem' style={{ color: filter === 'UIUX' ? '#161619' : '#7E7E86', fontWeight: filter === 'UIUX' ? '700' : null }} onClick={() => setFilter('UIUX')}>UIUX</div>
                        <div className='filterItem' style={{ color: filter === 'Motion' ? '#161619' : '#7E7E86', fontWeight: filter === 'Motion' ? '700' : null }} onClick={() => setFilter('Motion')}>Motion</div>
                        <div className='filterItem' style={{ color: filter === 'CG' ? '#161619' : '#7E7E86', fontWeight: filter === 'CG' ? '700' : null }} onClick={() => setFilter('CG')}>CG</div>
                        <div className='filterItem' style={{ marginRight: '40px', color: filter === 'Video' ? '#161619' : '#7E7E86', fontWeight: filter === 'Video' ? '700' : null }} onClick={() => setFilter('Video')}>Video</div>
                    </div>
                    <hr className='filter-hr' />
                    <div className='cards flex'>
                        <div className='cards-empty-space-left' />
                        <img className='cards-arrow' src={arrow_l} alt="" onClick={moveItem} />
                        <div className='cards-empty-space' />
                        <div className='flex cards-container'>
                        <motion.div
                            className='flex motion-div'
                            animate={{ x, y, rotate }}
                            transition={{ type: "spring", stiffness: 300, damping: 30 }}
                        >
                            {itemList.filter(item => item.type === filter || filter === 'all').map(filteredItem => (
                                <div className='flex'>
                                    <CircleCard serveType={serveType} id={filteredItem.id} type={filteredItem.type} title={filteredItem.title} image={filteredItem.image} />
                                    <div style={{ width: '5rem' }} />
                                </div>
                            ))}
                        </motion.div>
                        <div className='cards-empty-space-right' />
                                <img className='cards-arrow' src={arrow_r} alt="" onClick={moveItemBackward} />
                        </div>
                    </div>
                </div>
                <SecondFooter fashion={false} visual={false} media={true} />
            </div>
        </div>
    )
}

export default Media
